module.exports = __webpack_public_path__ + "./docs/img/vox-ios.87d66193cd6506f1d5d839c545abccbb.svg";